import Grid from '@material-ui/core/Grid';

/** @deprecated Exporting the Grid component from the Material-UI library. */
export default Grid;
